import Button from "../UI/Button"
import { IActionAreaProps } from "./types"

function ActionArea(props: IActionAreaProps) {

  return (
    <div style={props.style} className="action-area-component">
        <div className="action-area-component__top">
          {props.children}
          <div className="action-area-component__bottom">
            {props.buttonAction && props.buttonText && (
              <Button
                style={props.buttonStyle}
                onClick={() => props.disabled || !props.buttonAction ? null : props.buttonAction()} 
                type="primary" 
                disabled={props.disabled}
              >
                <p {...props.innerProps}>{props.buttonText}</p>
              </Button>
            )}
          </div>
        </div>
    </div>
  )
}

export default ActionArea